import { darken, getValue } from "../utils.js";

export const YES_NO = {
  "Yesno.Selected.Bg.Color": {
    ref: "Color.Primary.500"
  },
  "Yesno.Selected.Color": {
    ref: "Color.Text.Gray.White.Inverse"
  },
  "Yesno.Unselected.Bg.Color": {
    ref: "Color.Gray.200",
    referredIn: ["Yesno.Unselected.Hover.Color"]
  },
  "Yesno.Unselected.Color": {
    ref: "Color.Gray.400"
  },
  "Yesno.Border.Color": {
    value: "transparent"
  },
  "Yesno.Border.Top.Width": {
    value: "0"
  },
  "Yesno.Border.Bottom.Width": {
    value: "0"
  },
  "Yesno.Border.Left.Width": {
    value: "0"
  },
  "Yesno.Border.Right.Width": {
    value: "0"
  },
  "Yesno.Padding.Top": {
    ref: "Space.6"
  },
  "Yesno.Padding.Right": {
    ref: "Space.12"
  },
  "Yesno.Padding.Bottom": {
    ref: "Space.6"
  },
  "Yesno.Padding.Left": {
    ref: "Space.12"
  },
  "Yesno.Button.Gap": {
    ref: "Space.4"
  },
  "Yesno.Border.Top.Left.Radius": {
    ref: "Input.Border.Top.Left.Radius"
  },
  "Yesno.Border.Top.Right.Radius": {
    ref: "Input.Border.Top.Right.Radius"
  },
  "Yesno.Border.Bottom.Right.Radius": {
    ref: "Input.Border.Bottom.Right.Radius"
  },
  "Yesno.Border.Bottom.Left.Radius": {
    ref: "Input.Border.Bottom.Left.Radius"
  },
  "Yesno.Font.Size": {
    ref: "Input.Font.Size"
  },
  "Yesno.Font.Weight": {
    ref: "Input.Font.Weight"
  },
  "Yesno.Line.Height": {
    ref: "Input.Line.Height"
  },
  "Yesno.Letter.Spacing": {
    ref: "Input.Letter.Spacing"
  },
  "Yesno.Selected.Hover.Bg.Color": {
    ref: "Color.Primary.600"
  },
  "Yesno.Unselected.Hover.Bg.Color": {
    ref: "Color.Gray.300"
  },
  "Yesno.Selected.Hover.Color": {
    ref: "Color.Bg.White"
  },
  "Yesno.Unselected.Hover.Color": {
    valueFunc: (meta) => {
      // need to check the color
      return darken(getValue("Yesno.Unselected.Bg.Color", meta), 0.15);
    }
  },
  "Yesno.Selected.Focus.Shadow": {
    ref: "Yesno.Selected.Bg.Color"
  },
  "Yesno.Unselected.Focus.Shadow": {
    ref: "Yesno.Unselected.Bg.Color"
  },
  "Yesno.Selected.Disabled.Border.Color": {
    defaultValue: "transparent"
  },
  "Yesno.Unselected.Disabled.Border.Color": {
    defaultValue: "transparent"
  },
  "Yesno.Selected.Disabled.Bg.Color": {
    ref: "Color.Gray.300"
  },
  "Yesno.Unselected.Disabled.Bg.Color": {
    ref: "Color.Gray.100"
  },
  "Yesno.Selected.Disabled.Color": {
    ref: "Color.Text.White"
  },
  "Yesno.Unselected.Disabled.Color": {
    ref: "Color.Text.Gray.300"
  }
};
